export default "__VITE_PUBLIC_ASSET__418a1f31__"